import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from '@mui/material';
import { useSelector } from 'react-redux';

const ChildrenList = ({ onEdit, onDelete }) => {
  const children = useSelector((state) => state.children.children);


  return (
    <TableContainer component={Paper}>
      <Table aria-label="children table">
        <TableHead>
          <TableRow>
            <TableCell>ID Copil</TableCell>
            <TableCell>Nume</TableCell>
            <TableCell>E-mail Părinte Principal</TableCell>
            <TableCell>E-mail Părinte Secunda</TableCell>
            <TableCell>Data Nașterii</TableCell>
            <TableCell>Acțiuni</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {children.map((child) => (
            <TableRow key={child.child_id}>
              <TableCell>{child.child_id}</TableCell>
              <TableCell>{child.name}</TableCell>
              <TableCell>{child.primary_parent_email}</TableCell>
              <TableCell>{child.secondary_parent_email}</TableCell>
              <TableCell>{child.date_of_birth}</TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => onEdit(child)}
                  style={{ marginRight: '8px' }}
                >
                  Editează
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => onDelete(child.child_id)}
                >
                  Șterge
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ChildrenList;
